module.exports = __webpack_public_path__ + "media/welcome.69b5d0c0.webm";